import React, { useState, useEffect } from "react";
import { Box, SxProps, Typography } from "@mui/material";
import { useConfig, formatPrice } from "@thekilroygroup/shared-ui";
import { useCountUp } from "use-count-up";

export const TotalPrice = (props: {
  currency: string;
  pricesFromTitle: string;
  priceTotal: number;
}) => {
  const { currency, pricesFromTitle, priceTotal } = props;
  const { locale } = useConfig();

  const [lowestTotalAmount, setLowestTotalAmount] = useState(0);
  const [localLowestTotalAmount, setLocalLowestTotalAmount] =
    useState(lowestTotalAmount);

  const { value: animatedLowestTotalAmount, reset: countLowestTotalAmount } =
    useCountUp({
      isCounting: true,
      start: localLowestTotalAmount,
      end: lowestTotalAmount,
      duration: 0.4,
      onComplete: () => {
        setLocalLowestTotalAmount(lowestTotalAmount);
      },
    });

  useEffect(() => {
    setLowestTotalAmount(priceTotal);
  }, [priceTotal]);

  useEffect(() => {
    countLowestTotalAmount();
  }, [lowestTotalAmount, priceTotal]);

  /**
   * Logic for counting the lowest price total and lowest tax and surcharges END
   */
  return (
    <Box sx={rowStyles}>
      <Typography variant="titleMedium" weight="bold">
        {pricesFromTitle}
      </Typography>
      <Typography variant="titleMedium" weight="bold">
        {formatPrice(animatedLowestTotalAmount, locale, currency)}
      </Typography>
    </Box>
  );
};

const rowStyles: SxProps = {
  display: "flex",
  flexWrap: "nowrap",
  justifyContent: "space-between",
  gap: 8,
};
